import { Module } from 'vuex';

import { RootState } from '@/store';

import defaultState, { getters } from './state';
import mutations from './mutations';
import actions from './actions';

// export * from './mutations';

export default function (): Module<typeof defaultState, RootState> {
  return {
    namespaced: true,
    state: defaultState,
    actions,
    getters,
    mutations,
  };
}
